import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { IfFeatureEnabledDirective,IfFeatureDisabledDirective } from './directives/feature.directive';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    IfFeatureDisabledDirective,
    IfFeatureEnabledDirective
  ],
  exports: [ IfFeatureDisabledDirective, IfFeatureEnabledDirective]
})
export class CoreModule { }
